var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row border-top"},[_c('div',{staticClass:"col-12"},[_c('img',{staticClass:"mt-5 mb-5",attrs:{"src":require("../../assets/brunch-menu-2026.jpg")}})])])])
}]

export { render, staticRenderFns }